import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { getAuthToken } from '../../interceptors/api.interceptor';

declare let videojs: any;

@Component({
  selector: 'audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild('audioFileElement', {static: true}) audioFileElement: ElementRef;
  @Output() uploaded: EventEmitter<any> = new EventEmitter();
  @Input() file: any;
  @Input() poster: any;

  private static videoJsInstance: Promise<any> | null = null;

  viewReady = false;
  config: any;
  videoMessage = {
    show: true,
    message: '',
    loader: true
  };

  public ngOnInit(): void {
    if (this.file) {
      this.initAudioFile();
    }

  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['file'] &&
        changes['file'].currentValue &&
        this.viewReady) {
      this.initAudioFile();
    }

    if (changes['poster'] &&
        changes['poster'].currentValue &&
        this.file &&
        this.viewReady) {
      this.initAudioFile();
    }
  }

  public ngAfterViewInit(): void {
    this.viewReady = true;
  }

  public ngOnDestroy(): void {
    console.log('ngOnDestroy');
  }

  private initAudioFile(): void {
    this.videoMessage = {
      show: true,
      message: 'Audio file is being processed...',
      loader: true
    };

    this.config = {
      html5: {
        nativeAudioTracks: false,
        nativeVideoTracks: false,
        hls: {
          debug: true,
          overrideNative: false
        }
      },
      autoplay: false,
      controls: true,
      preload: 'auto'
    };

    let fileSrc = {
      withCredentials: true
    };

    if (this.file && this.file.transcoded) {
      fileSrc = Object.assign(fileSrc, {
        src: this.file.transcoded.playlistUrl,
        type: 'application/x-mpegURL'
      });

      if (this.file.transcoded && (this.file.transcoded.state === 'COMPLETE' || this.file.transcoded.state === 'COMPLETED')) {
        this.initVideo(fileSrc);
        Object.assign(this.videoMessage, {
          show: false,
          message: ''
        });
      }

      if (this.file.transcoded && this.file.transcoded.state === 'ERROR') {
        Object.assign(this.videoMessage, {
          message: 'Audio file error.',
          loader: false
        });
      }
    } else if (
      this.file &&
      !this.file.transcoded &&
      this.file.statusCode !== 'NOT_SUPPORTED') {
      fileSrc = Object.assign(fileSrc, {
        src: (window.URL || window['webkitURL']) ? URL.createObjectURL(this.file) : this.file,
        type: this.file.type
      });

      Object.assign(this.videoMessage, {
        show: false,
        message: ''
      });
      this.initVideo(fileSrc);
    } else if (
      this.file &&
      !this.file.transcoded &&
      this.file.statusCode === 'NOT_SUPPORTED') {
      Object.assign(this.videoMessage, {
        message: 'Audio file error.',
        loader: false
      });
    }
  }

  private initVideo(fileSrc: any) {
    this.loadVideoJs()
      .then(videojs => {
        console.log('videojs: ', videojs);
        const player = new videojs(this.audioFileElement.nativeElement, this.config, () => {
          player.src(fileSrc);

          player.on('error', e => {
            console.error('error: ', e);
          });

          if (this.poster) {
            player.poster(this.poster);
          }


          videojs.Vhs.xhr.beforeRequest = (options) => {
            console.log('videojs vhs.xhr.beforeRequest: ', options);

            // if (options.uri.startsWith('/api')) {
            //   options.uri = this.document.location.origin + this.videoUrl;
            // }

            const auth = getAuthToken();
            console.log('videojs auth: ', auth);
            if (auth) {
              options.headers = options.headers || {};
              options.headers['Notd-Auth'] = auth;
            }

            // zero timeout can hang forever
            if (options.timeout < 1) {
              console.log('videojs low timeout: ', options);
              options.timeout = 30000;
            }

            if (options.timeout > 60000) {
              console.log('videojs high timeout: ', options);
              options.timeout = 60000;
            }

            return options;
          };


        });
      });
  }

  private loadVideoJs(): Promise<any> {
    if (!AudioPlayerComponent.videoJsInstance) {
      AudioPlayerComponent.videoJsInstance = import('video.js').then(module => module.default);
    }
    return AudioPlayerComponent.videoJsInstance;
  }
}
